import { render, staticRenderFns } from "./LoopEmailSetting.vue?vue&type=template&id=ef51851a&scoped=true"
import script from "./LoopEmailSetting.vue?vue&type=script&lang=js"
export * from "./LoopEmailSetting.vue?vue&type=script&lang=js"
import style0 from "./LoopEmailSetting.vue?vue&type=style&index=0&id=ef51851a&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef51851a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef51851a')) {
      api.createRecord('ef51851a', component.options)
    } else {
      api.reload('ef51851a', component.options)
    }
    module.hot.accept("./LoopEmailSetting.vue?vue&type=template&id=ef51851a&scoped=true", function () {
      api.rerender('ef51851a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/loop/components/LoopEmailSetting.vue"
export default component.exports